var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-sidebar"},[_c('div',{staticClass:"toggle-sidebar-link",on:{"click":_vm.toggleMenu}},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{class:['sidebar-content', {'sidebar-content--opened': _vm.isOpened}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }